var storefrontApp = angular.module('storefrontApp');
storefrontApp.controller('detailsController', [
    '$scope', '$rootScope', '$window', '$document', 'detailsService', 'urlService', 'randomService', 'modalService', "storefrontApp.mainContext", "loaderService", "helperService", "validationService", function (
        $scope, $rootScope, $window, $document, detailsService, urlService, randomService, modalService, storefrontAppMainContext, loaderService, helperService, validationService
    ) {
        $scope.windowWidth = $window.innerWidth;
        angular.element($window).bind('resize', function () {
            $scope.windowWidth = $window.innerWidth;
            $scope.getActiveInspirations();
        });
        $scope.inspiartionsActiveIndex = 4;
        $scope.ratingDesc = ['Not Yet Rated', 'Awful', 'Poor', 'Average', 'Good', 'Excellent'];
        var referProductDefault = {
            toEmailId: '',
            fromEmailId: '',
            message: '',
            copyMe: false,
            itemId: '',
            isProject: true
        }
        $scope.$watch(
            function () {
                return storefrontAppMainContext.customer;
            },
            function () {
                $scope.customer = storefrontAppMainContext.customer;
            }
        );

        //#region Helper Functions

        $scope.toggleModal = function (key, state) {
            if (state) {
                modalService.open(key);
            }
            else {
                modalService.close(key);
            }
        }

        $scope.getNumber = function (num) {
            return new Array(num);
        }

        $scope.getProjectImageUrl = function (name) {
            return urlService.getImageUrl(
                {
                    "definitionName": "project_tutorial",
                    "imgName": name
                }
            );
        }

        $scope.getAuthorProjectsUrl = function (authorId, authorName) {
            return urlService.getAuthorProjectsUrl(authorId, authorName);
        }

        $scope.getProjectUrl = function (name, sku) {
            return urlService.getProductUrl(
                {
                    "definitionName": "project_tutorial",
                    "name": name,
                    "sku": sku != null && sku !== "" ? String(sku) : sku
                }
            );
        }

        $scope.showAlert = function (message) {
            alert(message);
        }

        function trackProjectRelatedDesignClick(action, details) {
            if (typeof gtag === "undefined" || gtag === null) {
                return;
            }
            gtag("event", "project_tutorial_related_click", {
                event_category: "learning_center",
                event_action: action,
                project_id: String($scope.projectId || ""),
                product_id: details.productId || "",
                product_name: details.productName || "",
                link_url: details.linkUrl || ""
            });
        }

        function initProjectRelatedDesignTracking() {
            var section = document.getElementById("related-products-used");
            if (!section || section.getAttribute("data-tracking-bound") === "true") {
                return;
            }
            section.setAttribute("data-tracking-bound", "true");
            section.addEventListener("click", function (evt) {
                var target = evt.target;
                if (!target || !target.closest) {
                    return;
                }
                if (target.closest(".quick-view")) {
                    return;
                }
                var productCard = target.closest(".product[role='listitem']");
                if (!productCard) {
                    return;
                }
                var productId = "";
                var productName = "";
                var nameEl = productCard.querySelector(".name");
                if (nameEl) {
                    productName = (nameEl.textContent || "").trim();
                }
                var addBtn = productCard.querySelector(".btn.cart");
                if (addBtn && addBtn.id) {
                    var idMatch = addBtn.id.match(/btn_related_add_(.+)/);
                    if (idMatch) {
                        productId = idMatch[1];
                    }
                }
                var action = "";
                var linkUrl = "";
                if (target.closest(".btn.cart")) {
                    action = "add_to_cart";
                } else if (target.closest(".more-like-this a")) {
                    action = "more_like_this";
                    var mlLink = target.closest(".more-like-this a");
                    linkUrl = mlLink ? mlLink.getAttribute("href") || "" : "";
                } else {
                    var link = target.closest("a[href]");
                    if (link) {
                        linkUrl = link.getAttribute("href") || "";
                        if (link.querySelector(".patch")) {
                            action = "patch_link";
                        } else if (link.getAttribute("itemprop") === "url") {
                            action = "product_link";
                        }
                    }
                }
                if (!action) {
                    return;
                }
                trackProjectRelatedDesignClick(action, {
                    productId: productId,
                    productName: productName,
                    linkUrl: linkUrl
                });
            });
        }

        $scope.showTimeinText = function (time) {
            var temp = time.split(':');
            var hours = temp[0];
            var minutes = undefined;
            if (temp && temp.length > 1) {
                minutes = temp[1];
                if (Number(minutes) < 1) {
                    minutes = undefined;
                }
            }
            if (Number(hours) < 1) {
                hours = undefined;
            }
            return ((angular.isDefined(hours) ? hours + ' Hour(s) ' : '') + (angular.isDefined(minutes) ? minutes + ' Minute(s) ' : ''))
        }

        function checkUserIsRegistered() {
            if ($scope.customer && $scope.customer.isRegisteredUser) {
                return true;
            }
            return false;
        }

        function imageZoom(imgID, resultID) {
            var img, lens, result, cx, cy;

            img = $document[0].getElementById(imgID);
            result = $document[0].getElementById(resultID);

            var lens = $document[0].getElementById('img-zoom-lens');
            if (lens) {
                lens.parentElement.removeChild(lens);
            }

            lens = document.createElement("DIV");
            lens.setAttribute("class", "img-zoom-lens");
            lens.setAttribute("id", "img-zoom-lens");
            img.parentElement.insertBefore(lens, img);

            /*calculate the ratio between result DIV and lens:*/
            cx = result.offsetWidth / lens.offsetWidth;
            cy = result.offsetHeight / lens.offsetHeight;

            result.style.left = '-30000px';
            result.style.backgroundImage = "url('" + img.src + "')";
            img.addEventListener('load', function () {
                result.style.backgroundImage = "url('" + img.src + "')";
                result.style.backgroundSize = (img.width * cx) + "px " + (img.height * cy) + "px";
            });

            /*execute a function when someone moves the cursor over the image, or the lens:*/
            lens.addEventListener("mousemove", moveLens);
            img.addEventListener("mousemove", moveLens);

            lens.addEventListener("mouseleave", hideLens);
            img.addEventListener("mouseleave", hideLens);

            /*and also for touch screens:*/
            lens.addEventListener("touchmove", moveLens, { passive: true });
            img.addEventListener("touchmove", moveLens, { passive: true });

            function hideLens(e) {
                result.style.left = '-30000px';
            }

            function moveLens(e) {
                var pos, x, y;
                e.preventDefault();
                pos = getCursorPos(e);

                result.style.left = '100%';
                /*calculate the position of the lens:*/
                x = pos.x - (lens.offsetWidth / 2);
                y = pos.y - (lens.offsetHeight / 2);

                /*prevent the lens from being positioned outside the image:*/
                if (x > img.width - lens.offsetWidth) { x = img.width - lens.offsetWidth; }
                if (x < 0) { x = 0; }
                if (y > img.height - lens.offsetHeight) { y = img.height - lens.offsetHeight; }
                if (y < 0) { y = 0; }

                /*set the position of the lens:*/
                lens.style.left = x + "px";
                lens.style.top = y + "px";
                result.style.backgroundSize = (img.width * cx) + "px " + (img.height * cy) + "px";
                result.style.backgroundPosition = "-" + (x * cx) + "px -" + (y * cy) + "px";
            }

            function getCursorPos(e) {
                var a, x = 0, y = 0;
                e = e || window.event;
                a = img.getBoundingClientRect();
                x = e.pageX - a.left;
                y = e.pageY - a.top;
                x = x - window.pageXOffset;
                y = y - window.pageYOffset;
                return { x: x, y: y };
            }
        }

        $scope.getProjectPdfUrl = function () {
            return "";
        }

        $scope.getProjectAuthorImgUrl = function (imgName) {
            return window.__env.projectAuthorImgBaseUrl + imgName;
        }
        //#endregion

        //#region Get Emproidery projects for page
        $scope.getEmbroideryProjects = function () {
            detailsService.getEmbroideryProjects(15).then(
                function (response) {
                    if (response && response.data) {

                        if ($scope.authorsProjects && $scope.authorsProjects.length > 0) {
                            var filteredProjects = response.data.filter(
                                function (x) {
                                    return !$scope.authorsProjects.filter(
                                        function (y) {
                                            return y.projectId == x.projectId
                                        }
                                    ).length
                                }
                            );
                        }
                        else {
                            filteredProjects = response.data;
                        }

                        var projects = randomService.getRandomItemsfromListArray(
                            filteredProjects, 7
                        );

                        $scope.popularProjects = projects.slice(0, 3);
                        $scope.posts = projects.slice(3);
                        $scope.posts.forEach(function (post) {
                            post.authorProjectsUrl = $scope.getAuthorProjectsUrl(post.fK_AuthorId, post.authorName);
                            post.url = $scope.getProjectUrl(post.title, post.projectId);
                            post.imgUrl = $scope.getProjectImageUrl(post.imageURL);
                        });
                    }
                }
            );
        }
        //#endregion

        $scope.onNavClick = function (navOption) {
            switch (navOption) {
                case "prev":
                    if ($scope.windowWidth > 1599 && $scope.inspiartionsActiveIndex - 5 > 0) {
                        $scope.inspiartionsActiveIndex =
                            $scope.inspiartionsActiveIndex - 1;
                        $scope.inspirations.pop();
                        $scope.inspirations.unshift(
                            $scope.inspirationsMaster[
                            $scope.inspiartionsActiveIndex - 5
                            ]
                        );
                    }
                    else if ($scope.windowWidth < 1600 && $scope.inspiartionsActiveIndex - 4 > 0) {
                        $scope.inspiartionsActiveIndex =
                            $scope.inspiartionsActiveIndex - 1;
                        $scope.inspirations.pop();
                        $scope.inspirations.unshift(
                            $scope.inspirationsMaster[
                            $scope.inspiartionsActiveIndex - 4
                            ]
                        );
                    }
                    break;
                default:
                    if (
                        $scope.inspiartionsActiveIndex < $scope.inspirationsMaster.length
                    ) {
                        $scope.inspiartionsActiveIndex =
                            $scope.inspiartionsActiveIndex + 1;
                        $scope.inspirations.splice(0, 1);
                        $scope.inspirations.push(
                            $scope.inspirationsMaster[
                            $scope.inspiartionsActiveIndex - 1
                            ]
                        );
                    }
                    break;
            }
        };

        $scope.getActiveInspirations = function () {
            if (angular.isDefined($scope.inspirationsMaster) && $scope.inspirationsMaster.length > 0) {
                if ($scope.windowWidth > 1599) {
                    $scope.inspiartionsActiveIndex = 5;
                    $scope.inspirations = angular.copy($scope.inspirationsMaster).splice(0, 5);
                }
                else {
                    $scope.inspiartionsActiveIndex = 4;
                    $scope.inspirations = angular.copy($scope.inspirationsMaster).splice(0, 4);
                }
            }
        }

        //#region Project Details Info
        function applyProjectPayloadFromData(data) {
            if (!data) {
                return;
            }
            $scope.currentProject = data;
            var imageFileName = data.imageFileName || "";
            $scope.currentProject.imgUrl = $scope.getProjectImageUrl(imageFileName);
            $scope.hasGIF = imageFileName.toLowerCase().includes(".gif") ? true : false;
            $scope.currentProject.authorName =
                (data.authorFirstName || "") + " " + (data.authorLastName || "");
            $scope.currentProject.authorProjectsUrl = $scope.getAuthorProjectsUrl(
                $scope.currentProject.authorId,
                $scope.currentProject.authorName
            );
            $scope.currentProduct = $scope.currentProject;
            $scope.projectDetailsInteractiveUi = true;
            $scope.getProjectsByAuthorId($scope.currentProject.authorId);
            $scope.getMaterialsContent();
            $scope.enhanceProjectStepCards();
            $scope.getPreviousNextEmbroideryProjects();
            $scope.getProjectInspirations($scope.projectId);
            $scope.getProjectReviewsById();
            $scope.loadRecommendedStabilizersIfMissing();
            jQuery(function () {
                $(".ArticleImages").parent().parent().addClass("txt-center");
            });
        }

        $scope.getProjectInfo = function () {
            detailsService.getProjectById($scope.projectId).then(
                function (response) {
                    if (response && response.data) {
                        applyProjectPayloadFromData(response.data);
                    } else {
                        $scope.isInvalidProject = true;
                    }
                }
            );
        }

        $scope.loadProjectImgDetails = function () {
            var elm = document.getElementById('prdMainImg');
            var lgElm = document.getElementById('prdLgImg');
            if (angular.isDefined(elm) && elm != null) {
                elm.src = $scope.currentProject.imgUrl;
                lgElm.src = $scope.currentProject.imgUrl;
                elm.style.display = 'block';
                //Image Zoom feature
                document
                    .getElementById("prdMainImg")
                    .addEventListener("load", function () {
                        var elm = document.getElementById("zoom-result");
                        if (angular.isDefined(elm)) {
                            elm.style.display = "block";
                            elm.style.left = "100%";
                        }
                        imageZoom("prdMainImg", "zoom-result");
                    });

                angular.element($window).bind("resize", function () {
                    imageZoom("prdMainImg", "zoom-result");
                    $scope.$digest();
                });
            }
        }

        function isValDefined(val) {
            return angular.isDefined(val);
        }

        function getElm(key) {
            return document.getElementById(key);
        }

        $scope.setImgSrc = function (imgSrcId, vdoSrcId, currentActivePrd) {
            var imgElm = getElm(imgSrcId);
            var vdoElm = getElm(vdoSrcId);
            if (
                isValDefined(imgElm) && imgElm != null &&
                isValDefined(currentActivePrd)
            ) {
                if (isValDefined(currentActivePrd.imgUrl) && currentActivePrd.imgUrl != null) {
                    imgElm.src = currentActivePrd.imgUrl;
                    imgElm.style.display = "block";

                    if (isValDefined(vdoElm) && vdoElm != null)
                        vdoElm.style.display = "none";
                }
                if (isValDefined(vdoElm) && vdoElm != null && isValDefined(currentActivePrd.videoUrl) && currentActivePrd.videoUrl != null) {
                    vdoElm.src = currentActivePrd.videoUrl;
                    vdoElm.style.display = "block";
                    imgElm.style.display = "none";
                }
            }
        };

        $scope.onInspirationImageClick = function (image) {
            $scope.currentProduct = image;
            $scope.setImgSrc("prdMainImg", "prdMainVideo", image);
        };

        //#endregion

        // #region Other Projects from the author
        $scope.getProjectsByAuthorId = function (authorId) {
            detailsService.getProjectsByAuthorId(authorId).then(
                function (response) {
                    if (response && response.data) {
                        if (response.data.length > 0) {
                            // remove current Project
                            var filteredProjects = response.data.filter(function (obj) {
                                return obj.projectId != $scope.projectId;
                            });

                            $scope.authorsProjects = randomService.getRandomItemsfromListArray(
                                filteredProjects, 3
                            );
                        }
                        $scope.getEmbroideryProjects();
                    }
                }
            );
        }
        //#endregion

        // #region Rating related
        $scope.getRatingImgSrc = function (currIndex) {
            if ($scope.rating.selectedValue > 0 || $scope.rating.hoveredValue > 0) {
                if ($scope.rating.selectedValue > 0 && $scope.rating.selectedValue >= currIndex) {
                    return $scope.rating.imgUrlActive;
                }
                else if ($scope.rating.hoveredValue > 0 && $scope.rating.hoveredValue >= currIndex) {
                    return $scope.rating.imgUrlActive;
                }
                else {
                    return $scope.rating.imgUrl;
                }
            }
            else {
                return $scope.rating.imgUrl;
            }
        }
        $scope.onRatingClick = function (currIndex) {
            $scope.rating.selectedValue = currIndex;
        }
        $scope.onRatingHover = function (currIndex) {
            $scope.rating.hoveredValue = $scope.rating.selectedValue > 0 ? 0 : currIndex;
        }
        $scope.onRatingLeave = function () {
            $scope.rating.hoveredValue = 0;
        }
        $scope.getRatingDesc = function () {
            var value = $scope.rating.hoveredValue;
            if ($scope.rating.selectedValue > 0) {
                value = $scope.rating.selectedValue;
            }
            if (value < 6) {
                return (value > 0 ? value.toFixed(1) + ' (' : '') + $scope.ratingDesc[value] + (value > 0 ? ')' : '');
            }
        }
        //#endregion

        // #region Feedback Related

        $scope.onFeedbackInput = function () {
            // Clear any existing timeout
            if (validationTimeout) {
                clearTimeout(validationTimeout);
            }
            // Immediate validation
            $scope.validateFeedback();
            // Also set a timeout for additional validation
            validationTimeout = setTimeout(function() {
                $scope.validateFeedback();
            }, 50);
        };

        $scope.validateFeedback = function () {
            if ($scope.rating.feedback && $scope.rating.feedback.length > 0) {
                $scope.isCommentValid = validationService.getRegularExpressions().feedbackComments.test($scope.rating.feedback);
            } else {
                $scope.isCommentValid = false;
            }
            // Force digest cycle to update the view
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        };

        // Add a more aggressive validation method
        $scope.validateFeedbackImmediate = function () {
            if ($scope.rating.feedback && $scope.rating.feedback.length > 0) {
                $scope.isCommentValid = validationService.getRegularExpressions().feedbackComments.test($scope.rating.feedback);
            } else {
                $scope.isCommentValid = false;
            }
        };

        // Initialize validation state
        $scope.isCommentValid = false;

        // Initialize validation on load with debouncing
        var validationTimeout;
        $scope.$watch('rating.feedback', function(newValue, oldValue) {
            if (newValue !== oldValue) {
                // Clear previous timeout
                if (validationTimeout) {
                    clearTimeout(validationTimeout);
                }
                // Set new timeout for debounced validation
                validationTimeout = setTimeout(function() {
                    $scope.validateFeedback();
                }, 100);
            }
        });

        $scope.onFeedbackSubmit = function () {
            if (checkUserIsRegistered()) {
                $scope.isFeedbackSubmitted = true;
                if ($scope.isCommentValid) {
                    loaderService.show();
                    // NEW: Send as JSON instead of FormData
                    var requestData = {
                        Id: 0,
                        FK_ProjectId: $scope.projectId,
                        FK_UserId: $scope.customer.contactId,
                        Rating: $scope.rating.selectedValue,
                        Feedback: $scope.rating.feedback,
                        Title: $scope.currentProject.title,
                        ProjectType: true,
                        IsAnonymous: false,
                        IsApproved: null,
                        IsDeleted: false,
                        ParentId: 0, // 0 - for new Comments
                        EnableNotifications: true,
                        DateRated: new Date(),
                        EcomUserEmail: $scope.customer.contact.email,
                        EcomUserFullName: $scope.customer.contact.fullName,
                    };

                    detailsService.submitprojectfeedback(requestData).then(
                        function (response) {
                            loaderService.hide();
                            if (response) {
                                $scope.rating.selectedValue = undefined;
                                $scope.rating.feedback = null;
                                $rootScope.$emit("ShowNotificationModal", { modalKey: "ProjectFeedbackSuccess" });
                            }
                            else {
                                $rootScope.$emit("ShowNotificationModal", { modalKey: "ProjectFeedbackError" });
                            }
                        },
                        function (error) {
                            loaderService.hide();
                            $rootScope.$emit("ShowNotificationModal", { modalKey: "ProjectFeedbackError" });
                        }
                    );
                }
            }
            else {
                var returnURL = $window.location.pathname + $window.location.search;
                $scope.outerRedirect($scope.baseUrl + "account/login?returnurl=" + returnURL.replace("&", "%26"));
            }
        }
        //#endregion

        //#region Img Large view
        $scope.onImageChange = function (selectedKey) {
            var id = 0;
            switch (selectedKey) {
                case "prev":
                    if ($scope.currentProduct.id > 0) {
                        id = $scope.currentProduct.id - 1;
                    }
                    break;
                default:
                    if (
                        $scope.currentProduct.id <=
                        $scope.inspirationsMaster.length &&
                        $scope.currentProduct.id >= 0
                    ) {
                        id = $scope.currentProduct.id + 1;
                    }
                    break;
            }
            $scope.currentProduct = {
                id: id,
                imgUrl: $scope.inspirationsMaster[id].imgUrl,
                videoUrl: $scope.inspirationsMaster[id].videoUrl,
            };
            $scope.setImgSrc(
                "prdLgImg",
                "prdLgVideo",
                $scope.currentProduct
            );
            $scope.setImgSrc(
                "prdMainImg",
                "prdMainVideo",
                $scope.currentProduct
            );
        };

        $scope.showLargerView = function () {
            $scope.toggleModal("imgLargeView", true);
            var prdLg = getElm("prdLg");
            var videoprdLg = document.createElement('video');
            videoprdLg.id = "prdLgVideo"
            videoprdLg.style.display = "none";
            videoprdLg.controls = true;
            videoprdLg.autoplay = true;
            videoprdLg.setAttribute('aria-hidden', 'true');
            prdLg.appendChild(videoprdLg);
            $scope.setImgSrc(
                "prdLgImg",
                "prdLgVideo",
                $scope.currentProduct
            );
        };
        //#endregion

        //#region Project section anchor navigation
        $scope.scrollToProjectSection = function ($event, sectionId) {
            if ($event) {
                $event.preventDefault();
            }

            var el = null;
            if (sectionId === "project-steps") {
                // Jump to the first numbered step card (not leftover article chrome)
                el = document.getElementById("project-step-1") ||
                    document.querySelector("#project-steps .prj-step-card[data-step-number]");
                if (!el) {
                    el = document.getElementById("project-steps");
                }
                // Show progress immediately when user intentionally opens Steps
                if ($scope.stepProgress && $scope.stepProgress.total > 0) {
                    var firstStep = document.querySelector("#project-steps .prj-step-card[data-step-number]");
                    var firstNum = firstStep
                        ? (parseInt(firstStep.getAttribute("data-step-number"), 10) || 1)
                        : 1;
                    $scope.stepProgress.visible = true;
                    $scope.stepProgress.current = firstNum;
                    $scope.stepProgress.percent = Math.round((1 / $scope.stepProgress.total) * 100);
                }
            } else {
                el = document.getElementById(sectionId);
            }

            if (!el) {
                return;
            }

            var headerEl = document.querySelector(".hdr.snip") || document.querySelector("header");
            var progressEl = document.querySelector(".prj-step-progress");
            var headerOffset = (headerEl && headerEl.offsetHeight) ? headerEl.offsetHeight + 12 : 80;
            // Keep sticky progress bar from covering the step title after jump
            if (sectionId === "project-steps" && progressEl) {
                headerOffset += progressEl.offsetHeight || 48;
            }
            var top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset;
            window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
        };
        //#endregion

        //#region Code to get project materials info from html
        function normalizeMaterialsListHtml(rawHtml) {
            var $fragment = $("<div>").html(rawHtml || "");
            var items = [];
            var seen = {};

            function pushItem(text) {
                var cleaned = String(text || "").replace(/\s+/g, " ").trim();
                if (!cleaned || seen[cleaned]) {
                    return;
                }
                seen[cleaned] = true;
                items.push(cleaned);
            }

            var $lis = $fragment.find("li");
            if ($lis.length) {
                $lis.each(function () {
                    pushItem($(this).text());
                });
            } else {
                $fragment.find(".ArticleLineItems").each(function () {
                    pushItem($(this).text());
                });
            }

            if (!items.length) {
                return rawHtml;
            }

            var $ul = $("<ul/>", { "class": "prj-materials-card__list" });
            items.forEach(function (text) {
                $ul.append($("<li/>").text(text));
            });
            return $ul.prop("outerHTML");
        }

        $scope.getMaterialsContent = function () {
            $scope.materialsContent = "";
            jQuery(function () {
                var extracted = "";
                $("#prj-content table tr .ArticleSubHeader").each(function () {
                    if ($(this).html().indexOf("Materials") > -1) {
                        var $fragment = $("<div>").html($(this).parent().parent().html());
                        $fragment.find(".ArticleSubHeader").remove();
                        extracted = normalizeMaterialsListHtml($fragment.html());
                        $(this).parent().parent().parent().remove();
                    }
                });
                if (extracted) {
                    $scope.$applyAsync(function () {
                        $scope.materialsContent = extracted;
                    });
                }
            });
        }
        //#endregion

        //#region Step cards (tutorial article HTML)
        $scope.enhanceProjectStepCards = function () {
            jQuery(function () {
                var $root = $("#project-steps");
                if (!$root.length) {
                    return;
                }

                $root.find("table").filter(function () {
                    var tableEl = this;
                    // Only tables that own an .ArticleStep (not ancestor wrappers)
                    return $(tableEl).find(".ArticleStep").filter(function () {
                        return $(this).closest("table")[0] === tableEl;
                    }).length > 0;
                }).each(function () {
                    var $table = $(this);
                    if ($table.closest(".prj-step-card").length) {
                        return;
                    }

                    var title = ($table.find(".ArticleStep").first().text() || "").trim();
                    var isPreface = /^preface/i.test(title);
                    var stepMatch = title.match(/step\s*(\d+)/i);
                    var stepNumber = stepMatch ? parseInt(stepMatch[1], 10) : null;

                    var cardClass = "prj-step-card" + (isPreface ? " prj-step-card--preface" : "");
                    var $card = $("<div/>", { "class": cardClass });
                    if (stepNumber != null && !isNaN(stepNumber)) {
                        $card.attr("data-step-number", String(stepNumber));
                        $card.attr("id", "project-step-" + stepNumber);
                    }

                    var $prev = $table.prev();
                    if ($prev.is("hr.ArticleHR")) {
                        $prev.addClass("prj-step-card__hr-hide");
                    }

                    $table.wrap($card);

                    if (stepNumber != null && !isNaN(stepNumber) && !isPreface) {
                        var $stepTitle = $table.find(".ArticleStep").first();
                        if (!$stepTitle.find(".prj-step-card__badge").length) {
                            $stepTitle.prepend(
                                $("<span/>", {
                                    "class": "prj-step-card__badge",
                                    "aria-hidden": "true",
                                    text: String(stepNumber)
                                })
                            );
                        }
                    }
                });

                $scope.initProjectStepProgress();
                $scope.initStepImageLightbox();
            });
        };
        //#endregion

        //#region Sticky step progress
        $scope.initProjectStepProgress = function () {
            if ($scope._stepProgressInitialized || !("IntersectionObserver" in window)) {
                return;
            }

            var steps = Array.prototype.slice.call(
                document.querySelectorAll("#project-steps .prj-step-card[data-step-number]")
            );
            if (!steps.length) {
                return;
            }

            $scope._stepProgressInitialized = true;

            // Prefer natural step order by data-step-number
            steps.sort(function (a, b) {
                return (parseInt(a.getAttribute("data-step-number"), 10) || 0) -
                    (parseInt(b.getAttribute("data-step-number"), 10) || 0);
            });

            var total = steps.length;
            var intersecting = [];

            $scope.$applyAsync(function () {
                $scope.stepProgress.total = total;
                $scope.stepProgress.current = parseInt(steps[0].getAttribute("data-step-number"), 10) || 1;
                $scope.stepProgress.percent = Math.round((1 / total) * 100);
                $scope.stepProgress.visible = false;
            });

            var headerEl = document.querySelector(".hdr.snip") || document.querySelector("header");
            var headerOffset = (headerEl && headerEl.offsetHeight) ? headerEl.offsetHeight + 8 : 80;

            function syncStepProgressFromIntersecting() {
                if (!intersecting.length) {
                    $scope.$applyAsync(function () {
                        $scope.stepProgress.visible = false;
                    });
                    return;
                }

                intersecting.sort(function (a, b) {
                    return a.getBoundingClientRect().top - b.getBoundingClientRect().top;
                });

                var active = intersecting[0];
                var n = parseInt(active.getAttribute("data-step-number"), 10);
                if (!n || isNaN(n)) {
                    return;
                }

                var index = steps.indexOf(active);
                var ordinal = index >= 0 ? index + 1 : n;

                $scope.$applyAsync(function () {
                    $scope.stepProgress.visible = true;
                    $scope.stepProgress.current = n;
                    $scope.stepProgress.percent = Math.round((ordinal / total) * 100);
                });
            }

            // Only show progress while a real numbered step card is on screen
            // (not when leftover materials / article chrome at the top of #project-steps is visible)
            var stepObserver = new IntersectionObserver(
                function (entries) {
                    entries.forEach(function (entry) {
                        var idx = intersecting.indexOf(entry.target);
                        if (entry.isIntersecting) {
                            if (idx < 0) {
                                intersecting.push(entry.target);
                            }
                        } else if (idx >= 0) {
                            intersecting.splice(idx, 1);
                        }
                    });
                    syncStepProgressFromIntersecting();
                },
                {
                    root: null,
                    rootMargin: "-" + headerOffset + "px 0px -40% 0px",
                    threshold: [0.15, 0.35, 0.6]
                }
            );

            steps.forEach(function (el) {
                stepObserver.observe(el);
            });
        };
        //#endregion

        //#region Step image lightbox
        var stepLightboxCache = {};

        function prefetchStepLightboxUrl(url) {
            if (!url || stepLightboxCache[url]) {
                return;
            }
            var img = new Image();
            img.onload = function () {
                stepLightboxCache[url] = true;
            };
            img.onerror = function () {
                stepLightboxCache[url] = true;
            };
            img.src = url;
        }

        function prefetchStepLightboxAround(index) {
            var items = $scope.stepLightbox.items || [];
            [index - 1, index, index + 1].forEach(function (i) {
                if (i < 0 || i >= items.length) {
                    return;
                }
                var item = items[i];
                if (item.preview) {
                    prefetchStepLightboxUrl(item.preview);
                }
                prefetchStepLightboxUrl(item.src);
            });
        }

        $scope.initStepImageLightbox = function () {
            if ($scope._stepLightboxInitialized) {
                return;
            }

            jQuery(function () {
                var $links = $("#project-steps a.stepImages");
                if (!$links.length) {
                    return;
                }

                $scope._stepLightboxInitialized = true;
                var items = [];

                $links.each(function () {
                    var $a = $(this);
                    var href = $a.attr("href");
                    if (!href) {
                        return;
                    }

                    var $card = $a.closest(".prj-step-card");
                    var stepNum = $card.length ? $card.attr("data-step-number") : "";
                    var $img = $a.find("img").first();
                    var imgAlt = ($img.attr("alt") || "").trim();
                    var preview = ($img.attr("src") || "").trim();

                    var stepTitle = "";
                    var stepDescription = "";
                    if ($card.length) {
                        stepTitle = ($card.find(".ArticleStep").first().text() || "").replace(/\s+/g, " ").trim();
                        var $clone = $card.clone();
                        $clone.find(".ArticleStep, a.stepImages, .prj-step-card__badge, .prj-step-image-link__zoom, .smallText, .prj-step-image-hint, script, style").remove();
                        stepDescription = ($clone.text() || "").replace(/\s+/g, " ").trim();
                        // Avoid repeating the step title when it was embedded in body text
                        if (stepTitle && stepDescription.indexOf(stepTitle) === 0) {
                            stepDescription = stepDescription.substring(stepTitle.length).replace(/^[:\s-]+/, "").trim();
                        }
                    }

                    items.push({
                        src: href,
                        preview: preview && preview !== href ? preview : "",
                        alt: imgAlt || (stepNum ? ("Step " + stepNum) : "Project step image"),
                        caption: stepNum ? ("Step " + stepNum) : (stepTitle || ""),
                        description: stepDescription
                    });

                    $a.addClass("prj-step-image-link");
                    if (!$a.find(".prj-step-image-link__zoom").length) {
                        $a.append(
                            '<span class="prj-step-image-link__zoom" aria-hidden="true"><i class="fas fa-search-plus"></i></span>'
                        );
                    }

                    $a.siblings(".smallText").removeClass("hide").addClass("prj-step-image-hint");
                    $a.parent().find(".smallText.hide").removeClass("hide").addClass("prj-step-image-hint");
                });

                $scope.$applyAsync(function () {
                    $scope.stepLightbox.items = items;
                });

                $links.off("click.prjStepLightbox").on("click.prjStepLightbox", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    var href = $(this).attr("href");
                    var idx = -1;
                    for (var i = 0; i < items.length; i++) {
                        if (items[i].src === href) {
                            idx = i;
                            break;
                        }
                    }
                    if (idx < 0) {
                        idx = 0;
                    }
                    $scope.$applyAsync(function () {
                        $scope.openStepLightbox(idx);
                    });
                });
            });
        };

        $scope.openStepLightbox = function (index) {
            var item = $scope.stepLightbox.items[index];
            if (!item) {
                return;
            }

            var token = Date.now();
            $scope.stepLightbox.loadToken = token;
            $scope.stepLightbox.index = index;
            $scope.stepLightbox.alt = item.alt;
            $scope.stepLightbox.caption = item.caption;
            $scope.stepLightbox.description = item.description || "";

            var hasPreview = !!item.preview;
            var fullCached = !!stepLightboxCache[item.src];

            // Instant paint with already-loaded page thumb when full isn't cached yet
            if (hasPreview && !fullCached) {
                $scope.stepLightbox.src = item.preview;
                $scope.stepLightbox.loading = true;
            } else {
                $scope.stepLightbox.src = item.src;
                $scope.stepLightbox.loading = !fullCached;
            }

            angular.element(document.documentElement).addClass("prj-lightbox-open");
            $scope.toggleModal("stepImageLightbox", true);
            prefetchStepLightboxAround(index);

            if (fullCached && (!hasPreview || $scope.stepLightbox.src === item.src)) {
                $scope.stepLightbox.loading = false;
                return;
            }

            var loader = new Image();
            loader.onload = function () {
                stepLightboxCache[item.src] = true;
                if ($scope.stepLightbox.loadToken !== token || $scope.stepLightbox.index !== index) {
                    return;
                }
                $scope.$applyAsync(function () {
                    $scope.stepLightbox.src = item.src;
                    $scope.stepLightbox.loading = false;
                });
            };
            loader.onerror = function () {
                if ($scope.stepLightbox.loadToken !== token || $scope.stepLightbox.index !== index) {
                    return;
                }
                $scope.$applyAsync(function () {
                    $scope.stepLightbox.loading = false;
                });
            };
            loader.src = item.src;
        };

        $scope.closeStepLightbox = function () {
            $scope.stepLightbox.loading = false;
            angular.element(document.documentElement).removeClass("prj-lightbox-open");
            $scope.toggleModal("stepImageLightbox", false);
        };

        $scope.onStepLightboxNav = function (delta) {
            var next = $scope.stepLightbox.index + delta;
            if (next < 0 || next >= $scope.stepLightbox.items.length) {
                return;
            }
            $scope.openStepLightbox(next);
        };

        angular.element($document).on("keydown.prjStepLightbox", function (e) {
            if (!angular.element(document.documentElement).hasClass("prj-lightbox-open")) {
                return;
            }

            if (e.key === "Escape" || e.keyCode === 27) {
                $scope.$applyAsync(function () {
                    $scope.closeStepLightbox();
                });
            } else if (e.key === "ArrowLeft" || e.keyCode === 37) {
                $scope.$applyAsync(function () {
                    $scope.onStepLightboxNav(-1);
                });
            } else if (e.key === "ArrowRight" || e.keyCode === 39) {
                $scope.$applyAsync(function () {
                    $scope.onStepLightboxNav(1);
                });
            }
        });
        //#endregion

        //#region Next and Previous Projects
        $scope.getPreviousNextEmbroideryProjects = function () {
            detailsService.getPreviousNextEmbroideryProjects($scope.projectId).then(
                function (response) {
                    if (response && response.data && response.data.length > 0) {
                        var projects = response.data;
                        $scope.showBottomNav = true;
                        projects.forEach(
                            function (proj) {
                                proj.url = $scope.getProjectUrl(proj.title, proj.projectId);
                                if (proj.projectId > $scope.projectId) {
                                    $scope.nextProject = proj;
                                }
                                else {
                                    $scope.prevProject = proj;
                                }
                            }
                        );
                    }
                }
            );
        }
        //#endregion

        //#region Project PDF Download
        $scope.projectPDFUrl = "";
        $scope.onProjectPdfDownload = function () {
            if (navigator.userAgent.toLowerCase().indexOf('firefox') < 0) {
                if ($scope.projectPDFUrl.length < 1) {
                    loaderService.show();
                    detailsService.getProjectPDFUrl($scope.projectId).then(
                        function (response) {
                            if (response && response.data) {
                                loaderService.hide();
                                $scope.projectPDFUrl = response.data;
                                helperService.downloadFileFromUrl($scope.projectPDFUrl, $scope.currentProject.title);
                            }
                        }
                    );
                }
                else {
                    helperService.downloadFileFromUrl($scope.projectPDFUrl, $scope.currentProject.title);
                }
            }
            else {
                $scope.onProjectPrint();
            }
        }

        //#region Product Print
        $scope.onProjectPrint = function () {
            if ($scope.projectPDFUrl.length < 1) {
                loaderService.show();
                detailsService.getProjectPDFUrl($scope.projectId).then(
                    function (response) {
                        if (response && response.data) {
                            loaderService.hide();
                            $scope.projectPDFUrl = response.data;
                            $scope.pdfsrc = $scope.projectPDFUrl;
                            $scope.toggleModal("viewProjectInstructionsModal", true);
                        }
                    }
                );
            }
            else {
                $scope.pdfsrc = $scope.projectPDFUrl;
                $scope.toggleModal("viewProjectInstructionsModal", true);
            }
        }

        $scope.onPrintMaterials = function () {
            var card = document.getElementById("project-materials");
            if (!card) {
                return;
            }

            var bodyEl = card.querySelector(".prj-materials-card__body");
            var listHtml = bodyEl ? bodyEl.innerHTML : "";
            if (!listHtml) {
                return;
            }

            document.body.classList.add("prj-print-materials-only");
            window.print();
            window.setTimeout(function () {
                document.body.classList.remove("prj-print-materials-only");
            }, 500);
        };
        //#endregion

        //#region Recommended stabilizers (by design type)
        var STABILIZER_RELATED_PATTERN = /stabilizer|tear[\s-]?away|cut[\s-]?away|wash[\s-]?away|water[\s-]?soluble|poly[\s-]?mesh|badgemaster/i;

        function relatedItemsAlreadyHaveStabilizer() {
            var root = document.getElementById("related-products-used");
            if (!root) {
                return false;
            }
            var names = [];
            var nameNodes = root.querySelectorAll(".name, a[title], img[alt]");
            for (var i = 0; i < nameNodes.length; i++) {
                var el = nameNodes[i];
                names.push(el.textContent || "");
                names.push(el.getAttribute("title") || "");
                names.push(el.getAttribute("alt") || "");
                names.push(el.getAttribute("href") || "");
            }
            return STABILIZER_RELATED_PATTERN.test(names.join(" "));
        }

        function normalizeCategoryKey(name) {
            return String(name || "")
                .toLowerCase()
                .replace(/[’']/g, "")
                .replace(/\s+/g, " ")
                .trim();
        }

        function resolveStabilizerRule(categoryNames) {
            var cfg = window.prjStabilizerRecommendations || {};
            var map = cfg.categoryToType || {};
            var types = cfg.types || {};
            var defaultType = cfg.defaultType || "filled";
            var typeKey = defaultType;
            var names = categoryNames || [];

            for (var i = 0; i < names.length; i++) {
                var key = normalizeCategoryKey(names[i]);
                if (map[key]) {
                    typeKey = map[key];
                    break;
                }
                var matched = null;
                Object.keys(map).forEach(function (syn) {
                    if (matched) {
                        return;
                    }
                    if (key.indexOf(syn) >= 0 || syn.indexOf(key) >= 0) {
                        matched = map[syn];
                    }
                });
                if (matched) {
                    typeKey = matched;
                    break;
                }
            }

            return types[typeKey] || types[defaultType] || null;
        }

        function formatStabilizerMoney(amount) {
            var n = Number(amount);
            if (isNaN(n)) {
                return "";
            }
            return "$" + n.toFixed(2);
        }

        function mapStabilizerProduct(item) {
            if (!item || !item.itemId) {
                return null;
            }
            var listPrice = item.listPrice;
            var salePrice = item.salePrice;
            var onSale = salePrice != null && listPrice != null && Number(salePrice) < Number(listPrice);
            var effective = onSale ? salePrice : listPrice;
            var defName = (item.definitionName || "Supplies").toLowerCase();
            var productUrl = urlService.getProductUrl({
                catalogId: item.catalog,
                definitionName: item.definitionName,
                name: item.name,
                sku: item.itemId
            });
            var imageUrl = urlService.getImageUrl({
                catalogId: item.catalog,
                definitionName: item.definitionName,
                size: "xlarge",
                sku: item.itemId
            });
            var clubDisplay = "";
            if (item.clubPrice != null && item.clubPrice !== "" && !isNaN(Number(item.clubPrice))) {
                clubDisplay = formatStabilizerMoney(item.clubPrice);
            }
            return {
                itemId: item.itemId,
                name: item.name,
                definitionName: defName,
                productUrl: (productUrl || "").toLowerCase(),
                imageUrl: imageUrl,
                moreLikeUrl: ("/matches/" + defName + "/" + item.itemId).toLowerCase(),
                onSale: onSale,
                listPriceDisplay: onSale ? formatStabilizerMoney(listPrice) : "",
                salePriceDisplay: formatStabilizerMoney(effective),
                clubPriceDisplay: clubDisplay
            };
        }

        function scoreByNameHints(name, hints) {
            var text = String(name || "").toLowerCase();
            var list = hints || [];
            var score = 0;
            for (var i = 0; i < list.length; i++) {
                var hint = String(list[i] || "").toLowerCase();
                if (hint && text.indexOf(hint) >= 0) {
                    score += list.length - i;
                }
            }
            return score;
        }

        function filterAndMapStabilizersByType(rows, rule) {
            var hints = (rule && rule.nameHints) || [];
            var maxItems = rule && rule.alternate ? 2 : 1;
            if (rule && rule.maxItems != null) {
                maxItems = Number(rule.maxItems) || maxItems;
            }

            var ranked = (rows || [])
                .map(function (row) {
                    return {
                        row: row,
                        score: scoreByNameHints(row && row.name, hints)
                    };
                })
                .filter(function (entry) {
                    return entry.row && entry.row.itemId && entry.score > 0;
                })
                .sort(function (a, b) {
                    return b.score - a.score;
                });

            var unique = [];
            var seen = {};
            ranked.forEach(function (entry) {
                if (unique.length >= maxItems) {
                    return;
                }
                var row = entry.row;
                if (seen[row.itemId]) {
                    return;
                }
                seen[row.itemId] = true;
                var mapped = mapStabilizerProduct(row);
                if (mapped) {
                    unique.push(mapped);
                }
            });
            return unique;
        }

        function fetchStabilizersForRule(rule, done) {
            var cfg = window.prjStabilizerRecommendations || {};
            var keyword = String(cfg.elasticKeyword || "stabilizer").trim();
            detailsService
                .getTopProducts({
                    definitionName: "Supplies",
                    keyword: keyword
                })
                .then(
                    function (response) {
                        done(filterAndMapStabilizersByType((response && response.data) || [], rule));
                    },
                    function () {
                        done([]);
                    }
                );
        }

        $scope.loadRecommendedStabilizersIfMissing = function () {
            $scope.recommendedStabilizers = {
                visible: false,
                items: []
            };

            jQuery(function () {
                if (relatedItemsAlreadyHaveStabilizer()) {
                    return;
                }

                var page = $window.__PROJECT_TUTORIAL_PAGE__ || {};
                var categoryNames = page.categoryNames || [];
                if ((!categoryNames || !categoryNames.length) && $scope.currentProject) {
                    categoryNames = $scope.currentProject.categoryNames || [];
                }

                var rule = resolveStabilizerRule(categoryNames);
                if (!rule) {
                    return;
                }

                fetchStabilizersForRule(rule, function (items) {
                    $scope.$applyAsync(function () {
                        if (!items.length || relatedItemsAlreadyHaveStabilizer()) {
                            $scope.recommendedStabilizers = { visible: false, items: [] };
                            return;
                        }
                        $scope.recommendedStabilizers = {
                            visible: true,
                            items: items
                        };
                    });
                });
            });
        };
        //#endregion

        $scope.scrollToAuthorSection = function ($event) {
            if ($event) {
                $event.preventDefault();
            }
            var el = document.getElementById("project-author");
            if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        };

        function initStickyPurchaseCta() {
            var related = document.getElementById("related-products-used");
            var sticky = document.getElementById("project-sticky-cta");
            if (!related || !sticky || typeof IntersectionObserver === "undefined") {
                return;
            }

            var relatedVisible = true;
            var navVisible = false;
            var navObserver = null;

            function updateStickyVisibility() {
                var show = !relatedVisible && !navVisible;
                sticky.classList.toggle("is-visible", show);
                sticky.setAttribute("aria-hidden", show ? "false" : "true");
                document.documentElement.classList.toggle("project-sticky-cta-open", show);
            }

            var relatedObserver = new IntersectionObserver(function (entries) {
                relatedVisible = entries[0].isIntersecting;
                updateStickyVisibility();
            }, { threshold: 0 });
            relatedObserver.observe(related);

            function observeBottomNav(nav) {
                if (!nav || navObserver) {
                    return;
                }
                navObserver = new IntersectionObserver(function (entries) {
                    navVisible = entries[0].isIntersecting;
                    updateStickyVisibility();
                }, { threshold: 0 });
                navObserver.observe(nav);
            }

            observeBottomNav(document.querySelector(".prj-det > .nav"));

            $scope.$watch("showBottomNav", function (visible) {
                if (!visible) {
                    return;
                }
                $scope.$evalAsync(function () {
                    observeBottomNav(document.querySelector(".prj-det > .nav"));
                });
            });
        }

        $scope.initialize = function () {
            if ($window.__PROJECT_DETAILS_NOT_FOUND__) {
                $scope.isInvalidProject = true;
                return;
            }
            $scope.projectDetailsInteractiveUi = false;
            $scope.stepProgress = {
                visible: false,
                current: 1,
                total: 0,
                percent: 0
            };
            $scope.stepLightbox = {
                items: [],
                index: 0,
                src: "",
                alt: "",
                caption: "",
                description: "",
                loading: false,
                loadToken: 0
            };
            $scope.recommendedStabilizers = {
                visible: false,
                items: []
            };
            $scope.rating = {
                maxValue: 5,
                hoveredValue: 0,
                selectedValue: 0,
                feedback: '',
                imgUrl: '/empty-rating-icon.svg',
                imgUrlActive: '/full-rating-icon.svg'
            };
            $scope.projectId = document.getElementById("projectid").value;
            $scope.productInfo = { _source: { videoLinks: [], variants: [] } };
            var initialPageData = $window.__PROJECT_TUTORIAL_PAGE__;
            var pid = parseInt($scope.projectId, 10);
            if (initialPageData && initialPageData.projectId != null && parseInt(initialPageData.projectId, 10) === pid) {
                applyProjectPayloadFromData(initialPageData);
            } else {
                $scope.getProjectInfo();
            }
            $rootScope.logoutUrl = "account/logout" + "?returnurl=" + $window.location.pathname;
            jQuery(function () {
                initProjectRelatedDesignTracking();
                initStickyPurchaseCta();
            });
        }
        //#endregion

        //#region Project Inspirations related
        $scope.getProjectInspirations = function (projectId) {
            detailsService.getProjectInspirations($scope.projectId).then(
                function (response) {
                    if (response && response.data) {
                        $scope.inspirationsMaster = [];
                        $scope.currentProduct = {
                            id: 0,
                            imgUrl: $scope.currentProject.imgUrl
                        };
                        $scope.inspirationsMaster.push($scope.currentProduct);
                        var inspirationitems = response.data;
                        angular.forEach(inspirationitems, function (item, key) {
                            var fileNames = item.fileNames;
                            var checkVideoExists = item.videoExists;
                            var video = undefined;
                            if (
                                checkVideoExists &&
                                angular.isDefined(window.__env) &&
                                angular.isDefined(window.__env.productVideosBaseUrl)
                            ) {
                                $scope.prjVideoExists = true;
                                var prd = getElm("prd");
                                var videoTag = document.createElement('video');
                                videoTag.id = "prdMainVideo"
                                videoTag.style.display = "none";
                                videoTag.controls = true;
                                videoTag.autoplay = true;
                                prd.appendChild(videoTag);
                                var videoUrl = urlService.getProductVideoUrl({
                                    catalogId: item.catalogId.replace(/ /g, "_").toLowerCase(),
                                    sku: item.itemId.split(/-(.+)/)[1],
                                });
                                video = {
                                    id: 1,
                                    videoUrl: videoUrl,
                                };
                                var prj = getElm("lg-video-container");
                                var prjVideoTag = document.createElement('video');
                                prjVideoTag.controls = true;
                                prjVideoTag.autoplay = true;
                                prjVideoTag.src = videoUrl;
                                prj.appendChild(prjVideoTag);
                            }
                            angular.forEach(fileNames, function (img, key) {
                                var imageUrl = urlService.getImageUrl({
                                    definitionName: item.productDefinition.toLowerCase(),
                                    size: "xlarge",
                                    catalogId: item.catalogId.replace(/ /g, "_").toLowerCase(),
                                    sku: item.itemId.split(/-(.+)/)[1],
                                });
                                imageUrl = imageUrl.replace(/.webp|.jpg|.gif/gi, function () {
                                    return "/" + img;
                                }
                                );
                                $scope.inspirationsMaster.push({
                                    id: key + 1 >= 1 && angular.isDefined(video) ? key + 2 : key + 1,
                                    imgUrl: imageUrl,
                                });
                            });
                            if (angular.isDefined(video)) {
                                $scope.inspirationsMaster.splice(1, 0, video);
                            }
                        });
                        $scope.getActiveInspirations();
                    }
                }
            );
        }

        //#region Project Comments related
        $scope.getProjectReviewsById = function () {
            $scope.checkUserIsLogged();
            detailsService.getProjectReviewsById($scope.projectId).then(
                function (response) {
                    if (response && response.data && response.data.length > 0) {
                        $scope.projectcomments = response.data;
                    }
                }
            )
        }

        $scope.checkUserIsLogged = function () {
            if ($scope.customer && $scope.customer.isRegisteredUser) {
                $scope.userLogged = true;
            }
            else {
                $scope.userLogged = false;
            }
        }
    }
]);
